var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex"}},[_c('treeselect',{attrs:{"multiple":true,"options":_vm.options,"value-consists-of":"LEAF_PRIORITY"},model:{value:(_vm.result),callback:function ($$v) {_vm.result=$$v},expression:"result"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }